import axiosInstance from "auth/FetchInterceptor";
import { OTHER_OPTION } from "constants/ApiConstant";
const OtherOptionService = {};

OtherOptionService.getAllOtherOptions = function (partnerId) {
  return axiosInstance.get(`${OTHER_OPTION}/${partnerId}`, null);
};

OtherOptionService.upsertOtherOption = function (data) {
  return axiosInstance.post(OTHER_OPTION, data);
};

OtherOptionService.deleteOtherOption = function (id) {
  return axiosInstance.delete(`${OTHER_OPTION}/${id}`, null);
};

export default OtherOptionService;
